export const customStyles = {
  headRow: {
    style: {
      backgroundColor: "#403e92", // Corrected color code
    },
  },
  headCells: {
    style: {
      color: "white",
      fontWeight: "500",
      justifyContent: "center",
      padding: "18px 8px",
      fontSize: "16px", // Adjust the font size as needed
    },
  },
  cells: {
    style: {
      justifyContent: "center",
      padding: "0 8px",
      fontSize: "14px", // Adjust the font size as needed
    },
  },
  rows: {
    style: {
      padding: "25px 0px",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "#F2F2F2",
      },
    },
  },
};
